import styled from 'styled-components'

interface Props {
	isSelected: boolean
}

export const RadioInputGroup = styled.div`
	display: flex;
	/* margin: 50px 0px 50px 0px; */
	margin: 0;
	/* padding: 30px 40px 0 40px; */

	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	padding: 15px 20px 10px 20px;
	gap: 15px;
`

export const RadioInputOption = styled.label`
	width: 100%;
	background: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
	/* padding: 0 20px 0 20px; */
	border: 1px solid #cecedf;
	border-radius: 8px;
	padding: 0 25px 0px 25px;
	box-sizing: border-box;
`

export const RadioInputOptionText = styled.p<Pick<Props, 'isSelected'>>`
	color: ${(props) => (props.isSelected ? '#000042' : '#333368')};
	font-weight: ${(props) => (props.isSelected ? '700' : '400')};
`

export const RadioImageInput = styled.input`
	display: none;
`
